/* ============================================================
   SHINE & STYLE — motion
   Scroll reveal and the back-to-top button.

   Reveal is opt-in per element via `data-reveal`, with an
   optional `data-reveal-stagger` on a container to walk its
   children in sequence.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     Stagger: give each child an index the CSS turns into a
     transition-delay. Done here rather than in the markup so
     Liquid loops don't have to count.
     --------------------------------------------------------- */
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-reveal-stagger]'),
    function (group) {
      var step = parseInt(group.getAttribute('data-reveal-stagger'), 10);
      if (isNaN(step) || step < 1) step = 1;

      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.hasAttribute('data-reveal')) child.setAttribute('data-reveal', '');
        // Cap the delay: past ~8 steps a late card feels broken
        // rather than choreographed.
        child.style.setProperty('--d', String(Math.min(i * step, 8)));
      });
    }
  );

  var targets = document.querySelectorAll('[data-reveal]');

  /* No IntersectionObserver, or motion is turned down: show
     everything immediately rather than leaving it invisible. */
  if (reduced || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);   // reveal once, never re-hide
      });
    }, {
      // Fire slightly before the element reaches the fold, so the
      // motion has finished by the time it is properly in view.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });

    /* Failsafe.
       The reveal start state is opacity:0, so anything the observer
       never reports stays invisible — the page silently loses its
       content. That can happen when the tab is restored in the
       background, inside an editor preview that isn't painting, or
       if the observer is throttled away. After 2.5s, show whatever
       is still hidden and stop waiting. Costs nothing when the
       observer is working normally, because it has already fired. */
    window.setTimeout(function () {
      var stuck = document.querySelectorAll('[data-reveal]:not(.is-in)');
      if (!stuck.length) return;
      Array.prototype.forEach.call(stuck, function (el) {
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, 2500);
  }

  /* ---------------------------------------------------------
     Back to top
     --------------------------------------------------------- */
  var toTop = document.querySelector('[data-to-top]');
  if (toTop) {
    var ticking = false;

    var update = function () {
      toTop.classList.toggle('is-visible', window.scrollY > 700);
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });

    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    update();
  }
})();
